module.exports = [{"name":"FSC_SUMO5041","version":1}]